// @core/api/endpoints/document/process_stage_action.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineExecutionResponse,
  ProcessStageActionRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Process stage action
 * Records that the current user has completed their action (acknowledge, approve, review, sign) in the active pipeline stage. If the completion rule is satisfied, the stage completes and the next stage begins.
 */
export async function ProcessStageAction(
  target_type: string,
  target_id: string,
  execution_id: string,
  data: ProcessStageActionRequest,
  options?: RequestOptions
): Promise<PipelineExecutionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/pipeline-executions/:execution_id/action`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  requestPath = requestPath.replace(':execution_id', encodeURIComponent(execution_id));
  const requestOptions = options;
  return client.post<PipelineExecutionResponse>(requestPath, data, requestOptions);
}
